// Pluralize acronym
export const pluralize = (word: string, count: number): string =>
  count === 1 ? word : `${word}s`;
